export const PROFILE_PICTURE_LABELS = {
  TITLE: 'Zdjęcie profilowe', // Profile Picture
  OPTIONAL: 'Opcjonalne', // Optional
  TOOLTIP_TITLE: 'Wymagania dotyczące zdjęcia profilowego:', // Profile image requirements:
  TOOLTIP_FORMAT: 'Format: PNG, JPG lub JPEG', // Format: PNG, JPG or JPEG
  TOOLTIP_SIZE: 'Maksymalny rozmiar pliku: 5 MB', // Maximum file size: 5 MB
} as const;
